import Marionette from "backbone.marionette";

export default Backbone.Collection.extend({
    url: "api/instances/index.php",
    //Overwrite behaviour for Hal+JSON data
    parse: function(data) {
        this.pageAttributes = {
            page: data.page,
            page_count: data.page_count,
            page_size: data.page_size,
            total_items: data.total_items
        };

        this.lang = data.lang;

        return data._embedded;
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/collections/instancesCollection.js
// module id = 162
// module chunks = 0